import {
  Drawer,
  Box,
  Avatar,
  Typography,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLayoutSideDrawer } from '../hooks/use-side-drawer';
import { useAuth } from '../../../hooks';
import { useLayoutStore } from '../../../store/layout';

export const LayoutSideDrawer = () => {
  const { t } = useTranslation();
  const { menuItems } = useLayoutSideDrawer();
  const { drawerOpen, handleDrawerClose } = useLayoutStore();
  const { username } = useAuth();

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={handleDrawerClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          boxSizing: 'border-box',
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar sx={{ mr: 2 }}>{username?.charAt(0).toUpperCase() || 'U'}</Avatar>
          <Typography variant="subtitle1" noWrap>
            {username || t('common.user')}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <List>
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;

            return (
              <ListItemButton key={index} onClick={item.onClick}>
                <ListItemIcon>
                  <IconComponent />
                </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
};
